// extracted by mini-css-extract-plugin
export default {"iag":"Settings_iag__34J+q","iac":"Settings_iac__n92MM"};